import { Card, Button } from "antd";
import { BsStarFill } from "react-icons/bs";
import { FaCheck, FaBolt, FaGem } from "react-icons/fa";

export const Membership = () => {
  return (
    <div>
      <h2 className="md:text-4xl text-3xl font-bold">멤버십</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 items-start justify-items-center max-w-[1200px] mx-auto">
        <Card
          className="w-full max-w-[350px] min-h-[600px] rounded-2xl border border-gray-200"
          styles={{ body: { padding: "32px" } }}
        >
          <div className="flex flex-col">
            <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center mb-4">
              <BsStarFill className="text-2xl text-[#1890ff]" />
            </div>

            <h3 className="text-3xl font-bold mb-2">스탠다드</h3>
            <p className="mb-6">캠페인 동시 운영</p>
            <p className="text-4xl font-bold text-[#2563EB] mb-6">
              월 65,000원
            </p>

            <Button
              type="primary"
              className="w-full h-12 rounded-lg bg-[#2563EB] mb-8 border-0 text-base font-semibold"
            >
              결제하기
            </Button>

            <div className="w-full">
              <h4 className="text-lg font-semibold mb-4">주요기능</h4>
              <div className="space-y-3 text-left">
                <p className="text-gray-700">Free의 모든 기능 +</p>
                <div className="flex items-start gap-2">
                  <FaCheck className="text-[#2563EB] mt-1 flex-shrink-0" />
                  <span className="text-gray-700">
                    인플루언서 캠페인 (동시 2건 운영)
                  </span>
                </div>
                <div className="flex items-start gap-2">
                  <FaCheck className="text-[#2563EB] mt-1 flex-shrink-0" />
                  <span className="text-gray-700">
                    누구나 참여 캠페인 (동시 2건 운영)
                  </span>
                </div>
                <div className="flex items-start gap-2">
                  <FaCheck className="text-[#2563EB] mt-1 flex-shrink-0" />
                  <span className="text-gray-700">
                    캠페인 인원 선정 (월 최대 15명)
                  </span>
                </div>
                <div className="flex items-start gap-2">
                  <FaCheck className="text-[#2563EB] mt-1 flex-shrink-0" />
                  <span className="text-gray-700">
                    인플루언서 상세 정보 열람
                  </span>
                </div>
                <div className="flex items-start gap-2">
                  <FaCheck className="text-[#2563EB] mt-1 flex-shrink-0" />
                  <span className="text-gray-700">캠페인 통계 데이터</span>
                </div>
                <div className="flex items-start gap-2">
                  <FaCheck className="text-[#2563EB] mt-1 flex-shrink-0" />
                  <span className="text-gray-700">
                    무제한 인플루언서 리스트
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Card>

        <Card
          className="w-full max-w-[350px] min-h-[600px] rounded-2xl border border-gray-200"
          styles={{ body: { padding: "32px" } }}
        >
          <div className="flex flex-col">
            <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center mb-4">
              <BsStarFill className="text-2xl text-[#1890ff]" />
            </div>

            <h3 className="text-3xl font-bold mb-2">프리미엄</h3>
            <p className="mb-6">캠페인 동시 운영</p>
            <p className="text-4xl font-bold text-[#2563EB] mb-6">
              월 65,000원
            </p>

            <Button
              type="primary"
              className="w-full h-12 rounded-lg bg-[#2563EB] mb-8 border-0 text-base font-semibold"
            >
              결제하기
            </Button>

            <div className="w-full">
              <h4 className="text-lg font-semibold mb-4">주요기능</h4>
              <div className="space-y-3 text-left">
                <p className="text-gray-700">Free의 모든 기능 +</p>
                <div className="flex items-start gap-2">
                  <FaCheck className="text-[#2563EB] mt-1 flex-shrink-0" />
                  <span className="text-gray-700">
                    인플루언서 캠페인 (동시 2건 운영)
                  </span>
                </div>
                <div className="flex items-start gap-2">
                  <FaCheck className="text-[#2563EB] mt-1 flex-shrink-0" />
                  <span className="text-gray-700">
                    누구나 참여 캠페인 (동시 2건 운영)
                  </span>
                </div>
                <div className="flex items-start gap-2">
                  <FaCheck className="text-[#2563EB] mt-1 flex-shrink-0" />
                  <span className="text-gray-700">
                    캠페인 인원 선정 (월 최대 15명)
                  </span>
                </div>
                <div className="flex items-start gap-2">
                  <FaCheck className="text-[#2563EB] mt-1 flex-shrink-0" />
                  <span className="text-gray-700">
                    인플루언서 상세 정보 열람
                  </span>
                </div>
                <div className="flex items-start gap-2">
                  <FaCheck className="text-[#2563EB] mt-1 flex-shrink-0" />
                  <span className="text-gray-700">캠페인 통계 데이터</span>
                </div>
                <div className="flex items-start gap-2">
                  <FaCheck className="text-[#2563EB] mt-1 flex-shrink-0" />
                  <span className="text-gray-700">
                    무제한 인플루언서 리스트
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Card>

        <Card
          className="w-full max-w-[350px] min-h-[600px] rounded-2xl border border-blue-400 relative bg-[#2563EB]"
          styles={{ body: { padding: "32px" } }}
        >
          <div className="flex flex-col">
            <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center mb-4">
              <FaGem className="text-2xl text-blue-500" />
            </div>

            <h3 className="text-3xl font-bold mb-2 text-white">엔터프라이즈</h3>
            <p className="text-blue-100 mb-6">캠페인 무제한 운영 + 공유</p>
            <p className="text-4xl font-bold text-white mb-6">월 188,000원</p>

            <Button className="w-full h-12 rounded-lg mb-8 bg-white text-[#2563EB] border-0 text-base font-semibold hover:bg-gray-100">
              결제하기
            </Button>

            <div className="w-full">
              <h4 className="text-lg font-semibold mb-4 text-white">
                주요기능
              </h4>
              <div className="space-y-3 text-left">
                <p className="text-blue-100">Lite의 모든 기능 +</p>
                <div className="flex items-start gap-2">
                  <FaBolt className="text-yellow-400 mt-1 flex-shrink-0" />
                  <span className="text-white">
                    무제한 인플루언서 캠페인 운영
                  </span>
                </div>
                <div className="flex items-start gap-2">
                  <FaBolt className="text-yellow-400 mt-1 flex-shrink-0" />
                  <span className="text-white">
                    무제한 누구나 참여 캠페인 운영
                  </span>
                </div>
                <div className="flex items-start gap-2">
                  <FaBolt className="text-yellow-400 mt-1 flex-shrink-0" />
                  <span className="text-white">무제한 캠페인 인원 선정</span>
                </div>
                <div className="flex items-start gap-2">
                  <FaBolt className="text-yellow-400 mt-1 flex-shrink-0" />
                  <span className="text-white">
                    인플루언서 캠페인 통계 외부 공유
                  </span>
                </div>
                <div className="flex items-start gap-2">
                  <FaBolt className="text-yellow-400 mt-1 flex-shrink-0" />
                  <span className="text-white">캠페인 제안</span>
                </div>
                <div className="flex items-start gap-2">
                  <FaBolt className="text-yellow-400 mt-1 flex-shrink-0" />
                  <span className="text-white">무제한 콘텐츠 마케팅 툴</span>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};
